export function checkBase64DataType(base64: string) {
  switch (base64.charAt(0)) {
    case '/':
      return 'jpg'
    case 'i':
      return 'png'
    case 'R':
      return 'gif'
    case 'U':
      return 'webp'
    default:
      return 'jpg'
  }
}

export function transformBase64(data: any) {
  return `data:image/${checkBase64DataType(data)};base64,${data}`
}
